import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import _slicedToArray from "/home/runner/work/ass/ass/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/runner/work/ass/ass/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { compileDrawing } from './drawing.js';
import { assign } from '../utils.js';
var tTags = ['fs', 'clip', 'c1', 'c2', 'c3', 'c4', 'a1', 'a2', 'a3', 'a4', 'alpha', 'fscx', 'fscy', 'fax', 'fay', 'frx', 'fry', 'frz', 'fr', 'be', 'blur', 'bord', 'xbord', 'ybord', 'shad', 'xshad', 'yshad'];
export function compileTag(tag, key) {
  var presets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var value = tag[key];
  if (value === undefined) {
    return null;
  }
  if (key === 'pos' || key === 'org') {
    return value.length === 2 ? _defineProperty({}, key, {
      x: value[0],
      y: value[1]
    }) : null;
  }
  if (key === 'move') {
    var _value = value,
      _value2 = _slicedToArray(_value, 6),
      x1 = _value2[0],
      y1 = _value2[1],
      x2 = _value2[2],
      y2 = _value2[3],
      _value2$ = _value2[4],
      t1 = _value2$ === void 0 ? 0 : _value2$,
      _value2$2 = _value2[5],
      t2 = _value2$2 === void 0 ? 0 : _value2$2;
    return value.length === 4 || value.length === 6 ? {
      move: {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        t1: t1,
        t2: t2
      }
    } : null;
  }
  if (key === 'fad' || key === 'fade') {
    if (value.length === 2) {
      var _value3 = value,
        _value4 = _slicedToArray(_value3, 2),
        _t = _value4[0],
        _t2 = _value4[1];
      return {
        fade: {
          type: 'fad',
          t1: _t,
          t2: _t2
        }
      };
    }
    if (value.length === 7) {
      var _value5 = value,
        _value6 = _slicedToArray(_value5, 7),
        a1 = _value6[0],
        a2 = _value6[1],
        a3 = _value6[2],
        _t3 = _value6[3],
        _t4 = _value6[4],
        t3 = _value6[5],
        t4 = _value6[6];
      return {
        fade: {
          type: 'fade',
          a1: a1,
          a2: a2,
          a3: a3,
          t1: _t3,
          t2: _t4,
          t3: t3,
          t4: t4
        }
      };
    }
    return null;
  }
  if (key === 'clip') {
    var _value7 = value,
      inverse = _value7.inverse,
      scale = _value7.scale,
      drawing = _value7.drawing,
      dots = _value7.dots;
    if (drawing) {
      return {
        clip: {
          inverse: inverse,
          scale: scale,
          drawing: compileDrawing(drawing),
          dots: dots
        }
      };
    }
    if (dots) {
      var _dots = _slicedToArray(dots, 4),
        _x = _dots[0],
        _y = _dots[1],
        _x2 = _dots[2],
        _y2 = _dots[3];
      return {
        clip: {
          inverse: inverse,
          scale: scale,
          drawing: drawing,
          dots: {
            x1: _x,
            y1: _y,
            x2: _x2,
            y2: _y2
          }
        }
      };
    }
    return null;
  }
  if (/^[xy]?(bord|shad)$/.test(key)) {
    value = Math.max(value, 0);
  }
  if (key === 'bord') {
    return {
      xbord: value,
      ybord: value
    };
  }
  if (key === 'shad') {
    return {
      xshad: value,
      yshad: value
    };
  }
  if (/^c\d$/.test(key)) {
    return _defineProperty({}, key, value || presets[key]);
  }
  if (key === 'alpha') {
    return {
      a1: value,
      a2: value,
      a3: value,
      a4: value
    };
  }
  if (key === 'fr') {
    return {
      frz: value
    };
  }
  if (key === 'fs') {
    return {
      fs: /^\+|-/.test(value) ? (value * 1 > -10 ? 1 + value / 10 : 1) * presets.fs : value * 1
    };
  }
  if (key === 't') {
    var _value8 = value,
      _t5 = _value8.t1,
      accel = _value8.accel,
      tags = _value8.tags;
    var _t6 = value.t2 || (presets.end - presets.start) * 1e3;
    var compiledTag = {};
    tags.forEach(function (t) {
      var k = Object.keys(t)[0];
      if (~tTags.indexOf(k) && !(k === 'clip' && !t[k].dots)) {
        assign(compiledTag, compileTag(t, k, presets));
      }
    });
    return {
      t: {
        t1: _t5,
        t2: _t6,
        accel: accel,
        tag: compiledTag
      }
    };
  }
  return _defineProperty({}, key, value);
}